export const filesToPayload = (files: File[]) => {
  const payload = new FormData();
  files.map((file) => payload.append('files', file));
  return payload;
};
